import Vue from 'vue'
import Router from 'vue-router'

// PAGES
import Home from '../components/content/home/'
import Lobby from '../components/content/lobby/'
import CaseLobby from '../components/content/case-lobby/'
import Done from '../components/content/done/'
import CaseProgress from '../components/content/case-progress/'

import Context from '../../src/assets/data/context.json'

Vue.use(Router)

let getItemOrDefault = function (key, defaultValue) {
  if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
    return defaultValue
  }
  return JSON.parse(localStorage.getItem(key))
}

// If there is no context variable, then redirect to home
let noDirectAccess = function (to, from, next) {
  let hasContext = getItemOrDefault(Context.current_context, null)
  if (hasContext === null) {
    next({path: '/'})
  } else {
    next()
  }
}

let router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/lobby/:cat',
      name: 'Lobby',
      props: true,
      component: Lobby
    },
    {
      path: '/case-lobby/:case',
      name: 'CaseLobby',
      props: true,
      component: CaseLobby
    },
    {
      path: '/case-progress',
      name: 'Progress',
      component: CaseProgress,
      beforeEnter: noDirectAccess
    },
    {
      path: '/case1',
      name: 'Case1',
      component: () => import('../components/content/cases/case1'),
      beforeEnter: noDirectAccess
    },
    {
      path: '/case2',
      name: 'Case2',
      component: () => import('../components/content/cases/case2'),
      beforeEnter: noDirectAccess
    },
    {
      path: '/case3',
      name: 'Case3',
      component: () => import('../components/content/cases/case3'),
      beforeEnter: noDirectAccess
    },
    {
      path: '/case4',
      name: 'Case4',
      component: () => import('../components/content/cases/case4'),
      beforeEnter: noDirectAccess
    },
    {
      path: '/case5',
      name: 'Case5',
      component: () => import('../components/content/cases/case5'),
      beforeEnter: noDirectAccess
    },
    {
      path: '/done',
      name: 'Done',
      component: Done,
      beforeEnter: noDirectAccess
    },
    {
      path: '/*',
      redirect: {name: 'Home'},
      name: 'Default',
      component: Home
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js